import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* istanbul ignore file */

/**
 * This file acts as the baseline for the rest of the themes, setting up print styles, a
 * default theme, type definitions, and the like. If something should be applied globally,
 * define it here.
 */

/* stylelint-disable no-descending-specificity */
import { css } from 'styled-components';
import { safariDetect, mobileDetect } from '@mummssoftware/utils/web';
import { widgetHeaderHeight, smallWidgetHeight, fullSizeHeight, widget1by1Height, widgetHeaderOverhead, fullSizeRatio } from '../dashboard';
export const isSafari = safariDetect();
export const isMobile = mobileDetect();
const textPrimaryColor = '#000000';
const textSecondaryColor = '#1d1d1d';
const backgroundColor = '#ffffff';
const headerColor = '#dcdcdc';
const basePrintRules = {
  bodyMargin: isSafari ? '0.05cm 0cm' : '0.25cm 1cm',
  backgroundColor,
  headerColor,
  textPrimaryColor,
  textSecondaryColor
};
export const commonPrintRules = _objectSpread({
  background: {
    '@media print': {
      background: backgroundColor,
      '-webkit-print-color-adjust': 'exact'
    }
  },
  header: {
    '@media print': {
      background: headerColor,
      '-webkit-print-color-adjust': 'exact'
    }
  },
  hide: {
    '@media print': {
      display: 'none'
    }
  },
  noBorder: {
    '@media print': {
      border: 'none'
    }
  },
  textPrimary: {
    '@media print': {
      color: textPrimaryColor
    }
  },
  textSecondary: {
    '@media print': {
      color: textSecondaryColor
    }
  }
}, basePrintRules);

const commonStyledPrintRules = _objectSpread({
  background: css(["@media print{background:", ";-webkit-print-color-adjust:exact;}"], backgroundColor),
  header: css(["@media print{background:", ";-webkit-print-color-adjust:exact;}"], headerColor),
  hide: css(["@media print{display:none;}"]),
  noBorder: css(["@media print{border:none;}"]),
  textPrimary: css(["@media print{color:", ";}"], textPrimaryColor),
  textSecondary: css(["@media print{color:", ";}"], textSecondaryColor)
}, basePrintRules);

const safariGlobal = css(["html,body{width:100%;}@media screen and (max-width:60em){input,textarea{font-size:16px !important;}}"]);
const safariPrint = css([".cert-wrap{width:511pt;height:8.8in !important;overflow:visible !important;top:0;left:0;position:fixed;}"]);
const defaultFlatPickrStyles = {
  fontColor: '#eee',
  disabledFontColor: 'rgba(255,255,255,0.4)',
  headerBackground: '#2e2e2e',
  selected: '#9edbf7',
  bg: '#454545',
  focus: '#3a3a3a',
  borders: 'rgba(39, 38, 38, 0.82)',
  icons: '#9edbf7',
  iconStroke: '#1f67af'
};
export const flatPickrStyles = ({
  fontColor = defaultFlatPickrStyles.fontColor,
  disabledFontColor = defaultFlatPickrStyles.disabledFontColor,
  headerBackground = defaultFlatPickrStyles.headerBackground,
  selected = defaultFlatPickrStyles.selected,
  bg = defaultFlatPickrStyles.bg,
  focus = defaultFlatPickrStyles.focus,
  borders = defaultFlatPickrStyles.borders,
  icons = defaultFlatPickrStyles.icons,
  iconStroke = defaultFlatPickrStyles.iconStroke
} = defaultFlatPickrStyles) => css([".flatpickr-weekdays,.flatpickr-months .flatpickr-month{background:", " !important;}.flatpickr-current-month .flatpickr-monthDropdown-months,.flatpickr-time{background:", " !important;color:", " !important;-webkit-text-fill-color:", " !important;}span.flatpickr-weekday{background:", " !important;color:", " !important;}.flatpickr-innerContainer{background:", " !important;}.flatpickr-day.selected,.flatpickr-day.startRange,.flatpickr-day.endRange,.flatpickr-day.selected.inRange,.flatpickr-day.startRange.inRange,.flatpickr-day.endRange.inRange,.flatpickr-day.selected:focus,.flatpickr-day.startRange:focus,.flatpickr-day.endRange:focus,.flatpickr-day.selected:hover,.flatpickr-day.startRange:hover,.flatpickr-day.endRange:hover,.flatpickr-day.selected.prevMonthDay,.flatpickr-day.startRange.prevMonthDay,.flatpickr-day.endRange.prevMonthDay,.flatpickr-day.selected.nextMonthDay,.flatpickr-day.startRange.nextMonthDay,.flatpickr-day.endRange.nextMonthDay{background:", " !important;color:", " !important;border-color:", " !important;}.flatpickr-day,.flatpickr-time input,.flatpickr-time .flatpickr-time-separator,.flatpickr-time .flatpickr-am-pm{color:", " !important;}.flatpickr-current-month .numInputWrapper span.arrowUp:after,.flatpickr-time .numInputWrapper span.arrowUp:after{border-bottom-color:", " !important;}.flatpickr-current-month .numInputWrapper span.arrowDown:after,.flatpickr-time .numInputWrapper span.arrowDown:after{border-top-color:", " !important;}.numInputWrapper:hover,.flatpickr-current-month .flatpickr-monthDropdown-months:hover,.flatpickr-time input:hover,.flatpickr-time .flatpickr-am-pm:hover,.flatpickr-time input:focus,.flatpickr-time .flatpickr-am-pm:focus{background:", " !important;}.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time,.numInputWrapper span{border-color:", " !important;}.flatpickr-time .flatpickr-time-separator{width:6px;}.flatpickr-calendar.arrowTop:after{border-bottom-color:", " !important;}.flatpickr-calendar{border:1px solid white;}.flatpickr-months .flatpickr-prev-month,.flatpickr-months .flatpickr-next-month{color:", " !important;fill:", " !important;}.flatpickr-months .flatpickr-prev-month:hover svg,.flatpickr-months .flatpickr-next-month:hover svg{color:", " !important;fill:", " !important;}.flatpickr-day.flatpickr-disabled,.flatpickr-day.flatpickr-disabled:hover,.flatpickr-day.prevMonthDay,.flatpickr-day.nextMonthDay,.flatpickr-day.notAllowed,.flatpickr-day.notAllowed.prevMonthDay,.flatpickr-day.notAllowed.nextMonthDay{color:", " !important;}.flatpickr-day:hover,.flatpickr-day:focus,.flatpickr-day.inRange,.flatpickr-day.today.inRange,.flatpickr-day.prevMonthDay.inRange,.flatpickr-day.nextMonthDay.inRange,.flatpickr-day.prevMonthDay.today.inRange,.flatpickr-day.nextMonthDay.today.inRange,.flatpickr-day.prevMonthDay:hover,.flatpickr-day.nextMonthDay:hover,.flatpickr-day.prevMonthDay:focus,.flatpickr-day.nextMonthDay:focus{background:", " !important;border-color:", " !important;}"], headerBackground, bg, icons, fontColor, headerBackground, fontColor, bg, selected, iconStroke, iconStroke, fontColor, icons, icons, focus, borders, icons, icons, icons, icons, icons, disabledFontColor, focus, focus);
export const commonGlobal = css(["", " @media print{html{font-size:", ";}@page{margin:20mm 15mm;}body{min-height:100%;margin:", " !important;overflow:visible !important;box-decoration-break:clone;}", "}:root{--safe-area-inset-top:env(safe-area-inset-top);--safe-area-inset-bottom:env(safe-area-inset-bottom);--safe-area-inset-left:env(safe-area-inset-left);--safe-area-inset-right:env(safe-area-inset-right);}"], isSafari ? safariGlobal : '', isSafari ? '.075in' : '12px', commonPrintRules.bodyMargin, isSafari ? safariPrint : '');
export default {
  palette: {
    primary: {
      main: '#bbe6f8'
    },
    chart: {
      // from Scheduler
      main: '#00938c'
    },
    graph: {
      border: '#000000',
      color: '#000000',
      graphColor: '#66ffcc',
      secondGraphColor: '#FF6A00'
    },
    scores: {
      color: '#6A6A6A'
    },
    grid: {
      fontColor: '#dddddd',
      headerBackground: '#000000',
      headerFontColor: '#bbe6f8',
      headerBorderColor: '#222222',
      rowBorderColor: '#313131',
      rowHoverBackground: '#404040'
    },
    error: {
      main: '#e04d4c'
    },
    background: {
      default: '#3a3a3a',
      paper: '#4d4d4d',
      header: '#2e2e2e',
      oddrow: '#403e3e',
      light: '#403e3e'
    },
    facesheet: {
      textColor: '#ffffff'
    },
    dashboard: {
      themeLoader: 'rgba(0, 0, 0, 0.8)'
    },
    text: {
      primary: '#ffffff',
      secondary: '#faf39b',
      hint: '#a3a3a3',
      notes: '#ffffff'
    },
    divider: '#3a3a3a'
  },
  typography: {
    useNextVariants: true,
    fontFamily: '"Muli", sans-serif'
  },
  overrides: {
    MuiBackdrop: {
      root: commonPrintRules.hide
    },
    MuiButtonBase: {
      root: commonPrintRules.hide
    },
    MuiInput: {
      underline: {
        '&:before': {
          bottom: 3
        },
        '&:after': {
          bottom: 3
        }
      }
    },
    MuiList: {
      padding: {
        paddingTop: '4px',
        paddingBottom: '4px'
      }
    },
    MuiPaper: {
      root: commonPrintRules.background
    },
    MuiTooltip: {
      tooltip: _objectSpread({
        fontSize: '.8em'
      }, commonPrintRules.hide)
    },
    MuiTypography: {
      root: commonPrintRules.textPrimary,
      body2: commonPrintRules.textPrimary,
      caption: commonPrintRules.textPrimary,
      colorInherit: commonPrintRules.textPrimary,
      colorPrimary: commonPrintRules.textPrimary,
      colorSecondary: commonPrintRules.textSecondary,
      colorTextPrimary: commonPrintRules.textPrimary,
      colorTextSecondary: commonPrintRules.textPrimary,
      colorError: commonPrintRules.textSecondary,
      paragraph: {
        marginBottom: '1em'
      },
      noWrap: {
        '@media print': {
          overflow: 'auto',
          whiteSpace: 'initial'
        }
      }
    }
  },
  props: {
    grid: {
      className: 'ag-theme-hummingbird'
    },
    dashboard: {
      widgetHeaderHeight,
      smallWidgetHeight,
      fullSizeHeight,
      widget1by1Height,
      widgetHeaderOverhead,
      fullSizeRatio
    },
    measures: {
      colorPrimary: '#9edbf7'
    },
    iconStroke: '#1f67af',
    header: {
      background: '#4d4d4d',
      leftTitle: {
        fontSize: 17.5,
        fontWeight: 400
      },
      rightTitle: {
        fontSize: 17.5,
        fontWeight: 400
      },
      headerHeight: '35px'
    },
    printRules: commonPrintRules,
    styledPrintRules: commonStyledPrintRules,
    isSafari,
    isMobile
  },
  global: `
  ${flatPickrStyles()}
  ${commonGlobal}`
};